"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _StandardIconWrapper = _interopRequireDefault(require("./StandardIconWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var AlertTriangleIcon =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(AlertTriangleIcon, _React$PureComponent);

  function AlertTriangleIcon() {
    _classCallCheck(this, AlertTriangleIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(AlertTriangleIcon).apply(this, arguments));
  }

  _createClass(AlertTriangleIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          color = _this$props.color,
          className = _this$props.className,
          props = _objectWithoutProperties(_this$props, ["color", "className"]);
      /* eslint-disable max-len */


      return _react.default.createElement(_StandardIconWrapper.default, _extends({
        className: (0, _classnames.default)(className, 'alert-triangle-icon')
      }, props), _react.default.createElement("path", {
        fill: color,
        d: "M6.81998867,5.08655126 L6.52188155,7.41251664 C6.49287113,7.63905903 6.29580032,7.8099423 6.0617162,7.8099423 L5.95267702,7.8099423 C5.71859291,7.8099423 5.52252246,7.63905903 5.49251168,7.41251664 L5.19440456,5.08655126 C5.13838443,4.6490901 5.45749909,4.2497115 5.90566013,4.19405237 C5.93967235,4.19014647 5.97368457,4.18819352 6.00769679,4.18819352 C6.45985927,4.18819352 6.82599083,4.54558367 6.82599083,4.98695073 C6.82599083,5.02112739 6.82399011,5.05335109 6.81998867,5.08655126 M5.99469212,10.0470484 C5.53852821,10.0470484 5.16839521,9.68575233 5.16839521,9.24047936 C5.16839521,8.79520639 5.53852821,8.43391034 5.99469212,8.43391034 C6.45085603,8.43391034 6.82098903,8.79520639 6.82098903,9.24047936 C6.82098903,9.68575233 6.45085603,10.0470484 5.99469212,10.0470484 M11.799778,9.65352863 L7.42720686,1.82805149 C7.14210442,1.31735464 6.59490779,1 5.99969392,1 C5.40448004,1 4.85828378,1.31735464 4.57218098,1.82707501 L0.200610157,9.65352863 C-0.077489771,10.1505548 -0.0654854576,10.7374168 0.230620941,11.2237017 C0.52572698,11.7099867 1.04791462,12 1.6281231,12 L10.3712647,12 C10.9514732,12 11.4736609,11.7099867 11.7697673,11.2237017 C12.0658737,10.7374168 12.0768776,10.1505548 11.799778,9.65352863"
      }));
      /* eslint-enable max-len */
    }
  }]);

  return AlertTriangleIcon;
}(_react.default.PureComponent);

exports.default = AlertTriangleIcon;
AlertTriangleIcon.defaultProps = {
  color: 'inherit'
};
AlertTriangleIcon.propTypes = {
  className: _propTypes.default.string,
  color: _propTypes.default.string
};